import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";

const ArchiveCompanyAddressModal = ({ open, onClose, onConfirm, address }) => {
  const addressLabel =
    address?.label ||
    [address?.addressLine1, address?.town, address?.postcode]
      .filter(Boolean)
      .join(", ");

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Archive Address</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to archive{" "}
          <strong>{addressLabel || "this address"}</strong>? This action cannot
          be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="outlined">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          Archive
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ArchiveCompanyAddressModal;